import { render, staticRenderFns } from "./ProfileGeneralSettings.vue?vue&type=template&id=1cf72898&scoped=true"
import script from "./ProfileGeneralSettings.vue?vue&type=script&lang=ts"
export * from "./ProfileGeneralSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf72898",
  null
  
)

export default component.exports